import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from '../../Home/register/register';

@Component({
  selector: 'app-procurement-hero',
  standalone: true,
  imports: [CommonModule, RegisterComponent],
  templateUrl: './procurement-hero.html',
  styleUrls: ['./procurement-hero.css'],
})
export class ProcurementHeroComponent {
  showRegister = false;
  procurementApp = [{ name: 'Procurement', image: 'images/webps/procurement.svg' }];
}
